
import { Vue, Component } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import DictSelect from '@/components/busi/custom/dictselect.vue'
import util from '@/utils/busi/util'
import { getUserAuthList, getUserAuthListCount, deleteUserAuthById } from '@/api/systemset'
import Modify from './edit/modify.vue'
import { MessageBox } from 'element-ui'
import { checkPermission } from '@/utils/permission'
@Component({
  name: 'user-auth',
  components: {
    SimpleTable,
    Modify,
    DictSelect
  }
})
export default class UserAuth extends Vue {
  private checkPermission: any = checkPermission

  private form: any = {
    loginAccount: '',
    userName: ''
  }

  private loading = !1

  private tableData = {
    list: [],
    totalCount: 2
  }

  private columns = [
    {
      prop: 'loginAccount',
      label: '登录账号',
      format: 'trim'
    },
    {
      prop: 'userName',
      label: '姓名'
    }
  ]

  private pagination: any = {
    currentPage: 1,
    pageSize: 10
  }

  private async onQuery (pagination: any = null) {
    this.loading = !0
    const form = util.trimForm({ ...this.form }, ['loginAccount', 'userName'])
    !pagination && (this.pagination.currentPage = 1)
    await getUserAuthList({
      ...form,
      ...pagination || this.pagination
    }).then(async (res: any) => {
      await getUserAuthListCount({
        ...form
      }).then((resCount: any) => {
        this.loading = !1
        this.tableData.list = res.object.list
        this.tableData.totalCount = resCount.object.totalCount
      })
    }).catch((err: any) => {
      console.log('err', err)
      this.loading = !1
    })
  }

  private onReset () {
    this.form = {
      loginAccount: '',
      userName: ''
    }
    this.onQuery()
  }

  // 新增权限配置
  private onAdd () {
    this.$router.push({
      name: 'userAuthEdit',
      params: { deadline: (new Date().getTime() + 315360000 * 1000) + '' }
    })
  }

  private dialogVisible = !1

  private grantData: any = {}

  private grantTitle: any = ''

  // 权限配置弹窗
  private onConfig (row: any) {
    this.grantData = row
    this.grantTitle = `${row.userName}用户权限配置`
    this.dialogVisible = !0
  }

  private closeDialog () {
    this.grantData = {}
    this.grantTitle = ''
  }

  private async onDelete (row: any) {
    MessageBox.confirm('提示：确认要删除该权限配置？', '删除配置', {
      confirmButtonText: '确定',
      cancelButtonText: '取消'
    }).then(async () => {
      await deleteUserAuthById({
        loginAccount: row.loginAccount,
        userName: row.userName
      }).then((res: any) => {
        if (res.code === 10000) {
          this.$message(res.message)
          this.onQuery()
        } else {
          this.$message.error(res.message)
        }
      }).catch((err: any) => {
        console.log('err', err)
      })
    }).catch((err: any) => {
      console.log('err', err)
    })
  }

  private async rowDbClick (row: any) {
    console.log('rowDbClick:', row)
  }

  mounted () {
    if (checkPermission(['powerList'])) {
      this.onQuery()
    }
  }
}
